<template>
  <router-view></router-view>
</template>
<script>
  export default {
    data() {
      return {
        SeciliBina: null,
        BinaBilgi: []
      }
    },
    created() {
      if (this.$store.getters.BinaBilgi) {
        this.BinaBilgi = this.$store.getters.BinaBilgi;
        this.SeciliBina = this.BinaBilgi.id;
        if (this.$route.path == '/yonetim/bina') this.$router.push("/yonetim/bina/" + this.BinaBilgi.id);
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Yonetim/bina.vue